import { render, staticRenderFns } from "./FeaturePermissionSelector.vue?vue&type=template&id=048528be&scoped=true&"
import script from "./FeaturePermissionSelector.vue?vue&type=script&lang=js&"
export * from "./FeaturePermissionSelector.vue?vue&type=script&lang=js&"
import style0 from "./FeaturePermissionSelector.vue?vue&type=style&index=0&id=048528be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "048528be",
  null
  
)

export default component.exports